import type { Theme } from "@mui/material";
import { createStyles, makeStyles } from "@mui/styles";
import type { FC } from "react";

const useStyles = makeStyles((theme: Theme) =>
    createStyles({
        "@global": {
            "*": {
                boxSizing: "border-box",
                margin: 0,
                padding: 0,
            },
            html: {
                "-webkit-font-smoothing": "antialiased",
                "-moz-osx-font-smoothing": "grayscale",
            },
            body: {
                backgroundColor: theme.palette.background.default,
            },
            ".u-text--primary": {
                color: `${theme.palette.primary.main} !important`,
            },
            ".u-text--error": {
                color: theme.palette.error.main,
            },
            ".MuiDialogContent-root": {
                whiteSpace: "pre-line",
            },
        },
    })
);

const GlobalStyles: FC = () => {
    useStyles();

    return null;
};

export default GlobalStyles;
